import { html } from 'lit';

import { renderGamAd } from '@client/adManager/AdUnit/renderAd.js';
import { AdVendor } from '@client/core/AdVendor.js';
import {
  AdServer,
  AdSlot,
  type PlacementId
} from '@schibsted-nmp/advertising-shared';

export class GamAdVendor extends AdVendor {
  constructor(placementId: PlacementId) {
    super(AdServer.Gam, placementId);
  }

  override updated() {
    // do nothing
  }

  override cleanupEvents() {
    // do nothing
  }

  override setupEvents() {
    // do nothing
  }

  override requestAd(containerElement?: Element | null) {
    renderGamAd(this.placementId, containerElement ?? null);
  }

  override render() {
    return html`
      <slot
        name="${AdSlot.fromPlacementId(this.placementId)}"
        id="${this.placementId}"
      ></slot>
    `;
  }
}
